import { richTextFieldActions } from 'components/shared/util/richTextField/actions/richTextField';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
import { bindActionToPromise } from 'utils/sagaApiGeneratorHelpers';

/** Represents the object that is returned after a file is uploaded. */
export type FileUploadStatus = {
  link: string;
};

/**
 * Function returned from the hook, allowing you to pass in a file and get back
 * a promise that resolves when the file is uploaded, returning the server url.
 */
export type UseFileUploadReturn = (file: File) => Promise<FileUploadStatus>;

/** Hook that returns a function that can be used to upload a file */
export function useFileUpload(): UseFileUploadReturn {
  const dispatch = useAppDispatch();

  const uploadAction = bindActionToPromise(
    dispatch,
    richTextFieldActions.richTextFieldAddAttachments,
  );

  const uploadFile = (file: File) =>
    uploadAction(file).then((result: { data: { link: string } }) => {
      return {
        link: result.data.link,
      };
    });

  return uploadFile;
}
